import React, { useEffect, useState } from 'react';

export default function TimeLabel (props) {
  return <>
    {(props.text && <span className="mb_label_time" title="영상길이">{props.text}</span>)}
  </>;
}
